import { useState } from "react";

import { useCopyToClipboard } from "@uidotdev/usehooks";

import { Button } from "@shared/components/ui/Button";
import { TextTooltip } from "@shared/components/ui/TextTooltip";
import { cn } from "@shared/utils/cn";

export const DebugValue = ({ label, value, autoHide = false }) => {
  const [_, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    copyToClipboard(value);
    setTimeout(() => {
      setIsCopied(false);
    }, 750);
  };

  if (autoHide && !value) {
    return null;
  }

  return (
    <div className="flex items-center w-full">
      <TextTooltip content="Copy" asChild>
        <Button
          variant="ghost"
          onClick={handleCopy}
          className="flex gap-2 relative overflow-hidden w-full justify-start"
        >
          <div
            className={cn(
              "absolute left-0 top-0 w-full h-full grid place-content-center bg-black/10 text-white backdrop-blur-sm font-semibold opacity-0 transition-all duration-200",
              isCopied && "opacity-1",
            )}
          >
            Copied
          </div>
          <span className="font-medium">{label}:</span>
          {value}
        </Button>
      </TextTooltip>
    </div>
  );
};
